export type MarketingPageKey = 'about' | 'pricing' | 'faq' | 'privacy' | 'terms' | 'help' | 'releases' | 'contact';

export const ROUTES = {
  ABOUT: '/about',
  PRICING: '/pricing',
  FAQ: '/faq',
  HELP: '/help',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  RELEASES: '/releases',
  CONTACT: '/contact',
  SETTINGS: '/settings'
} as const;
